import React from "react";
import "./fal-float.css";

// Tarjeta flotante del FAL: la misma de la home de ecovalores (repo eco-website, includes/fal-float.php), con los
// mismos textos. Cerrar la oculta sólo mientras dure la vista de la página.
const FalFloat = () => {
  const [open, setOpen] = React.useState(true);

  if (!open) return null;

  return (
    <aside className="fal-float" aria-labelledby="falFloatBand falFloatTitle">
      <div className="fal-float__band">
        <span className="fal-float__band-t" id="falFloatBand">PyMEs</span>
      </div>
      <a
        className="fal-float__go"
        href="https://www.ecovalores.com.ar/fondo-asistencia-laboral-fal-pymes.html"
        target="_blank"
        rel="noreferrer"
      >
        <span className="fal-float__title" id="falFloatTitle">Tu FAL, <em>resuelto.</em></span>
        <span className="fal-float__btn">
          Solicitar mi cuenta FAL
          <svg className="fal-float__arrow" width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      </a>
      <button type="button" className="fal-float__close" aria-label="Cerrar" onClick={() => setOpen(false)}>
        <svg width="12" height="12" viewBox="0 0 14 14" aria-hidden="true" focusable="false">
          <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" fill="none" />
        </svg>
      </button>
    </aside>
  );
};

export default FalFloat;
